import { Input, message, Modal, ConfigProvider, Collapse } from 'antd'
import { useState } from 'react'
import { Link } from 'react-router-dom'
import { post } from 'request/request'
import './footer.less'
import Qs from 'qs'
import { useIntl } from 'react-intl'

const { Panel } = Collapse;
export const Footer = () => {
  const [isModalVisible, setModalVisible] = useState(false)
  const [emailVal, setEmailVal] = useState('')
  const [msgVal, setMsgVal] = useState('')
  const intl = useIntl();

  
  const footerData = [{
    title: intl.formatMessage({id: 'footer.menus.INFO'}),
    children: [{
      title: intl.formatMessage({id: 'footer.menus.about.About'}),
      link: '/AboutUs',
    }, {
      title: intl.formatMessage({id: 'footer.menus.INFO.Installation'}),
      link: '/InstallationVideo/video',
    }, {
      title: intl.formatMessage({id: 'footer.menus.INFO.App'}),
      link: '/InstallationVideo/app',
    }, {
      title: intl.formatMessage({id: 'footer.menus.INFO.FAQ'}),
      link: '/FAQ',
    }]
  }, {
    title: intl.formatMessage({id: 'footer.menus.support'}),
    children: [{
      title: intl.formatMessage({id: 'footer.menus.support.Shipping'}),
      link: '/ShippingPolicy',
    },{
      title: intl.formatMessage({id: 'footer.menus.support.Return'}),
      link: '/ReturnRefundPolicy',
    }, {
      title: intl.formatMessage({id: 'footer.menus.support.Refund'}),
      link: '/RefundPolicy',
    }, {
      title: intl.formatMessage({id: 'footer.menus.support.Intellectual'}),
      link: '/IntellectualPropertyRights',
    }, {
      title: intl.formatMessage({id: 'footer.menus.support.Privacy'}),
      link: '/PrivacyPolicy',
    }, {
      title: intl.formatMessage({id: 'footer.menus.support.Terms'}),
      link: '/TermsofService',
    }]
  }, {
    title: intl.formatMessage({id: 'footer.menus.about'}),
    children: [{
      title: intl.formatMessage({id: 'footer.menus.about.Contact'}),
      link: '/ContactUs',
    }, {
      title: intl.formatMessage({id: 'footer.menus.support.Support'}),
      link: '/Support',
    }, {
      title: intl.formatMessage({id: 'footer.menus.about.Distributor'}),
      link: '/BecomeADistributor',
    }]
  }]

  const onSearch = () => {
    const value = emailVal
    const reg = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/;
    if (value.replace(/\s/g,'') === '') {
      message.error('Please input your E-mail!');
      return;
    }
    if (!reg.test(value)) {
      message.error('The input is not valid E-mail!');
      return;
    }
    setModalVisible(true);
    post('snailcar/user/common/yzmSend',Qs.stringify({email:value
    }),{headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    }}).then((data) => {
      setEmailVal(value)
    })
  };
  const subEmailFun = () => {
    if (msgVal.replace(/\s/g,'') === '') {
      message.error('Please enter the verification code!');
      return;
    }
    if (msgVal.length !== 6) {
      message.error('Incorrect verification code!');
      return;
    }
    setModalVisible(false)
    post('snailcar/user/common/subscribeEmail',{email:emailVal,yzm: msgVal
    }).then((data) => {
      message.success('successful!');
      setEmailVal('')
    })
  };

  return <div className="scar-footer-container">
      <div className='scar-footer-wrapper'>
        <div className='footer-menus-wrapper block-820-hiddle'>
          {footerData.map((item, index) => <ul className='footer-menus' key={index}>
            <div className='footer-menus-title'>{item.title}</div>
            {item.children.map((val, key) => <li key={key}><Link to={val.link}>{val.title}</Link></li>)}
          </ul>)}
          <div className='footer-contact-us'>
            <div className='footer-menus-title'>{intl.formatMessage({id: 'footer.SUBSCRIBE'})}</div>
            <input className='footer-contact-input' type="text" placeholder={intl.formatMessage({id: 'footer.enterAddress'})}
              value={emailVal}
              onChange={(e)=>{setEmailVal(e.target.value)}}
            />
            <div onClick={onSearch} className='footer-btn'>{intl.formatMessage({id: 'footer.Submit'})}</div>
          </div>
        </div>
        <div className='block-820'>
          <div className='footer-contact-us'>
            <div className='footer-menus-title'>{intl.formatMessage({id: 'footer.SUBSCRIBE'})}</div>
            <input className='footer-contact-input' type="text" placeholder={intl.formatMessage({id: 'footer.enterAddress'})}
              value={emailVal}
              onChange={(e)=>{setEmailVal(e.target.value)}}
            />
            <div onClick={onSearch} className='footer-btn'>{intl.formatMessage({id: 'footer.Submit'})}</div>
          </div>
          <Collapse className="collapse-wrapper" accordion ghost>
          {footerData.map((item, index) => 
              <Panel header={item.title} key={index}>
                  {item.children.map((val,key) => <Link key={key} to={val.link}><p>{val.title}</p></Link>)}
              </Panel>)}
          </Collapse>
        </div>
        {/* 海外的不显示备案，国内的显示备案 */}
        <div className='footer-bottom'>©2020 酷蜗牛（厦门）科技有限公司 版权所有 <a className='beian-link' href="https://beian.miit.gov.cn/#/Integrated/index" target='_blank'>闽ICP备2024032604号-1</a> | <a  className='beian-link' target='_blank' href="https://beian.mps.gov.cn/#/query/webSearch">闽公网安备35020502000811号</a></div>
      </div>
        <ConfigProvider
          // theme={{
          //   token: {
          //     colorPrimary: '#F6D3CE',
          //   },
          // }}
        >
           <Modal title="tips" open={isModalVisible} onOk={subEmailFun} onCancel={() => {setModalVisible(false)}}>
            <Input value={msgVal} placeholder="Please enter email verification code" onChange={(e) => {setMsgVal(e.target.value)}}/>
          </Modal>
        </ConfigProvider>
     
  </div>
}